
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  GetSkillsResponse,
} from '../models';
import {
    GetSkillsResponseFromJSON,
    GetSkillsResponseToJSON,
} from '../models';

export interface GetPublicSkillsFromProfileIdRequest {
    profileId: string;
}

/**
 * 
 */
export class PublicExpertiseApi extends runtime.BaseAPI {

    /**
     * List public skills of a given profile
          */
    async getPublicSkillsFromProfileIdRaw(requestParameters: GetPublicSkillsFromProfileIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<GetSkillsResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getPublicSkillsFromProfileId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<GetSkillsResponse>({
            path: `/profile/public-api/profiles/{profileId}/expertises/skills`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=GetSkillsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * List public skills of a given profile
          */
    async getPublicSkillsFromProfileId(requestParameters: GetPublicSkillsFromProfileIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<GetSkillsResponse> {
        const response = await this.getPublicSkillsFromProfileIdRaw(requestParameters, initOverrides);
        return response._data;
    }

}
